import React from 'react';
import { connect } from 'react-redux';

// utils
import removeTags from 'service_modules/utils/text-remove-tags';
import { sendDTMClickEvent } from 'service_modules/models/dtm-tagging';
import replaceStringWithVars from 'src/universal/utils/replaceStringWithVars';

// selectors
import {
  getCardTileDtm,
  makeGetLearnMoreUrl,
  makeGetCardArtUrl,
  makeGetCardTitle
} from '../redux';

// styles
import styles from '../__styles__/cardArt.scss?modules';

const CardArt = ({ shortName, dtmEvent, learnMoreUrl, cardArtUrl, cardTitle }) => {
  const clickHandler = () => {
    sendDTMClickEvent({
      ...dtmEvent,
      eventAsset: replaceStringWithVars({
        varsObject: {
          productName: shortName
        },
        string: dtmEvent.eventAsset
      })
    });
  };
  return (
    <a href={learnMoreUrl} onClick={clickHandler} className={styles.cardArtLink}>
      <img
        width="380"
        height="240"
        loading="lazy"
        src={cardArtUrl}
        alt={removeTags(cardTitle)}
      />
    </a>
  );
};

const mapStateToProps = () => {
  const getCardArtUrl = makeGetCardArtUrl();
  const getCardTitle = makeGetCardTitle();
  const getLearnMoreUrl = makeGetLearnMoreUrl();

  return (state, { shortName }) => ({
    shortName: shortName,
    dtmEvent: getCardTileDtm(state)?.cardArt?.dtm || {},
    learnMoreUrl: getLearnMoreUrl(state, shortName),
    cardArtUrl: getCardArtUrl(state, shortName),
    cardTitle: getCardTitle(state, shortName)
  });
};

export default connect(mapStateToProps)(CardArt);
